import { SubscriptionEnum } from "./types";
import { cookieCleanup } from "./utils";

const REACT_APP_ADMIN_BACKEND_REST_API_URL = process.env.REACT_APP_ADMIN_BACKEND_REST_API_URL;

async function fetchFromAPI(endpoint: string, body: unknown = {}) {
  const response = await fetch(`${REACT_APP_ADMIN_BACKEND_REST_API_URL}${endpoint}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
    credentials: 'include',
  });


  if (!response.ok) {
    if (response.status === 401) {
      // Remove the invalid cookie
      cookieCleanup();
    }
    try {
      const errorDetails = await response.json();
      console.log(`Error: ${errorDetails.error ? errorDetails.error : errorDetails}`)
      throw new Error(`Error: ${errorDetails.error ? errorDetails.error : errorDetails}`)
    } catch (error) {
      throw new Error(`API request failed: ${response.statusText}`);
    }
  }
  if(response.status === 204){
    return "NO_DATA_FOUND";
  }

  return response.json();
}

export async function getUsers() {
  return fetchFromAPI('/admin_dash/users');
}

export async function getUserSessions(userId: string, sessionType: SubscriptionEnum) {
  return fetchFromAPI('/admin_dash/sessions', { user_id: userId, session_type: sessionType });
}

export async function getSession(sessionId: string) {
  return fetchFromAPI('/admin_dash/sessions', { session_id: sessionId });
}

export async function getSessionQueries(sessionId: string) {
  return fetchFromAPI('/admin_dash/queries', { session_id: sessionId });
}

export async function getSearchResults(queryId: string) {
  return fetchFromAPI('/admin_dash/search_results', { query_id: queryId });
}

export async function getSearchResultsBySession(sessionId: string) {
  return fetchFromAPI('/admin_dash/search_results', { session_id: sessionId });
}

export async function getQueryAnswer(sessionId: string, queryId: string) {
  return fetchFromAPI('/admin_dash/answers', { session_id: sessionId, query_id: queryId });
}

export async function getAnswersBySession(sessionId: string) {
  return fetchFromAPI('/admin_dash/answers', { session_id: sessionId });
}

export async function getSuggestedQuestionsBySession(sessionId: string) {
  return fetchFromAPI('/admin_dash/suggested_questions', { session_id: sessionId });
}

export async function getUserBookmarks(userId: string, sessionType: SubscriptionEnum) {
  return fetchFromAPI('/admin_dash/bookmarks', { user_id: userId, session_type: sessionType });
}

export async function sendOtp(userEmail: string) {
  return fetchFromAPI('/admin_dash/auth/login', { user_email: userEmail });
}

export async function authenticateSession(userEmail: string, otp: string) {
  return fetchFromAPI('/admin_dash/auth/verify_otp', { user_email: userEmail, otp: otp });
}

export async function validateSession(userEmail: string) {
  return fetchFromAPI('/admin_dash/validate_session', { user_email: userEmail });
}

export async function getSessionDetails(sessionId: string) {
  const sessionDetails = {
    session_id: sessionId,
    queries: await getSessionQueries(sessionId),
    answers: await getAnswersBySession(sessionId),
    suggestedQuestions: await getSuggestedQuestionsBySession(sessionId),
    searchResults: await getSearchResultsBySession(sessionId),
  };
  return sessionDetails
}

export async function createUser(userEmail: string, userName: string | null, userTokens: number | null, subscriptions: string) {
  return fetchFromAPI('/admin_dash/create_user', { user_email: userEmail, user_name: userName, user_tokens: userTokens, subscriptions: subscriptions });
}

export async function addUserTokens(userId: string, userTokens: number) {
  return fetchFromAPI('/admin_dash/add_tokens', { user_id: userId, user_tokens: userTokens });
}

export async function signOut(userEmail: string | undefined) {
  return fetchFromAPI('/admin_dash/auth/signout', { user_email: userEmail });
}

export async function setUserSubscriptions(userId: string, subscriptions: string) {
  return fetchFromAPI('/admin_dash/set_user_subscriptions', { user_id: userId, subscriptions: subscriptions });
}